import React from 'react';
import { Card } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { customStyles } from '../../../../../Components/helper';
import CustomDatePicker from '../../../../../Components/Utility/DatePicker/DatePicker';

function MultiDestinationPackUnits({ lengthEnabled, data, fromAddEdit, forSwitch }) {
  const { t } = useTranslation('common');

  return (
    <Card className="card-margin-bottom rounded-0 pb-3">
      <Card.Header className="bgcolor-dark rounded-0">
        <div className="d-flex flex-wrap align-items-center p-2">
          <div className="custom-control custom-switch">
            <input
              type="checkbox"
              className="custom-control-input"
              id="multiDestinationPack"
              name="multiDestinationPack"
              onChange={forSwitch}
              disabled={!fromAddEdit}
              checked={data?.visible?.ratio}
            />
            <label className="custom-control-label" htmlFor="multiDestinationPack">
              <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.CARD_TITLE')}</strong>
            </label>
          </div>
          <div className="date my-2 my-md-0 pr-3 ml-md-auto">
            <div className="input-button-container bg-white">
              <CustomDatePicker
                dateFormat="dd/MM/yyyy"
                name="selectedActualApproveByDate"
                popperPlace="top-end"
                placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.HANDOVER')}
                disable
              />
            </div>
          </div>
          <div className="date justify-content-end pr-1">
            <div className="input-button-container bg-white">
              <CustomDatePicker
                dateFormat="dd/MMM/yyyy"
                name="selectedActualApproveByDate"
                popperPlace="top-end"
                placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.SHIPMENT')}
                disable
              />
            </div>
          </div>
        </div>
      </Card.Header>
      {(data?.visible?.ratio || fromAddEdit) && (
        <Card.Body>
          <div className="table-responsive">
            <table className="table custom-table xs-layout-fixed font-13 mb-5">
              <thead>
                <tr>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.SIZE')}</th>
                  {lengthEnabled && <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.LENGTH')}</th>}
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.PACK_RATIO')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.PRICE_BEFORE_DISCOUNT')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.DISCOUNT_PERCENT')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.PRICE_AFTER_DISCOUNT')}</th>
                  {fromAddEdit && <th className="w-80px" />}
                </tr>
              </thead>
              <tbody>
                <tr key={0}>
                  <td>
                    <div className="custom-react-select">
                      <Select name="Size" isDisabled styles={customStyles} placeholder="" />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" styles={customStyles} isDisabled placeholder="" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      name="Pack Ratio"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.ENTER_TEXT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (Before Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.ENTER_TEXT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Discount"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TEXT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (After Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TEXT')}
                      className="form-control text-bordered"
                      readOnly
                      disabled
                    />
                  </td>
                  {fromAddEdit && (
                    <td>
                      <button type="button" name="Delete" className="btn px-1">
                        <i className="icon-delete" />
                      </button>
                      <button name="Add" type="button" className="btn  px-1">
                        <i className="icon-add" />
                      </button>
                    </td>
                  )}
                </tr>
                <tr key={1}>
                  <td>
                    <div className="custom-react-select">
                      <Select name="Size" isDisabled styles={customStyles} placeholder="" />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" styles={customStyles} isDisabled placeholder="" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      name="Pack Ratio"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT._TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (Before Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT._TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Discount"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.PO_TEXT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (After Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.PO_TEXT')}
                      className="form-control text-bordered"
                      readOnly
                      disabled
                    />
                  </td>
                  {fromAddEdit && (
                    <td>
                      <button type="button" name="Delete" className="btn px-1">
                        <i className="icon-delete" />
                      </button>
                      <button type="button" name="Add" className="btn  px-1">
                        <i className="icon-add" />
                      </button>
                    </td>
                  )}
                </tr>
                <tr key={2}>
                  <td>
                    <div className="custom-react-select">
                      <Select name="Size" isDisabled styles={customStyles} placeholder="" />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" styles={customStyles} isDisabled placeholder="" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      name="Pack Ratio"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.ENTER_TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (Before Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.ENTER_TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Discount"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.MULTI_TEXTS')}
                      className="form-control text-border"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (After Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.MULTI_TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  {fromAddEdit && (
                    <td>
                      <button type="button" name="Delete" className="btn px-1">
                        <i className="icon-delete" />
                      </button>
                      <button type="button" name="Add" className="btn  px-1">
                        <i className="icon-add" />
                      </button>
                    </td>
                  )}
                </tr>

                <tr key={3}>
                  <td colSpan={lengthEnabled ? 9 : 8}>
                    <strong className="d-flex align-item-center justify-content-center">
                      {t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL')}
                    </strong>
                  </td>
                </tr>
                <tr key={4}>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.AUTO_FILLED')}</strong>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.AUTO_FILLED')}</strong>
                    </td>
                  )}
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.AUTOFILLED')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.AUTOFILLED')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.AUTOFILLEDS')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.AUTOFILLEDS')}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="table-responsive">
            <table className="table custom-table font-13 mb-5">
              <thead />
              <tbody>
                <tr key={0}>
                  <td colSpan={6}>
                    <input
                      type="text"
                      name="destination"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.DESTINATION_PLACEHOLDER')}
                      className="form-control text-bordered"
                      disabled
                    />
                    <div className="d-flex align-items-center my-1">
                      <span>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_PACKS_LABEL')}</span>
                      <div className="ml-auto">
                        <input
                          type="text"
                          name="packsQuantity"
                          placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_PACKS_TITLE')}
                          className="form-control text-bordered"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="d-flex align-items-center my-1">
                      <span>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_')}</span>
                      <div className="ml-auto">
                        <input
                          type="text"
                          name="totalUnits"
                          placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_UNITS_LABEL')}
                          className="form-control text-bordered"
                          disabled
                        />
                      </div>
                    </div>
                  </td>
                  {fromAddEdit && (
                    <td className="w-80px">
                      <button type="button" name="Delete" className="btn px-1">
                        <i className="icon-delete" />
                      </button>
                      <button type="button" name="Add" className="btn  px-1">
                        <i className="icon-add" />
                      </button>
                    </td>
                  )}
                </tr>
                <tr key={1}>
                  <td colSpan={6}>
                    <input
                      type="text"
                      name="destination"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.DESTINATION_PLACEHOLDER')}
                      className="form-control text-bordered"
                      disabled
                    />
                    <div className="d-flex align-items-center my-1">
                      <span>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_PACKS_LABEL')}</span>
                      <div className="ml-auto">
                        <input
                          type="text"
                          name="packsQuantity"
                          placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_PACK')}
                          className="form-control text-bordered"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="d-flex align-items-center my-1">
                      <span>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_UNITS_LABEL')}</span>
                      <div className="ml-auto">
                        <input
                          type="text"
                          name="totalUnits"
                          placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_UNIT')}
                          className="form-control text-bordered"
                          disabled
                        />
                      </div>
                    </div>
                  </td>
                  {fromAddEdit && (
                    <td className="w-80px">
                      <button type="button" name="Delete" className="btn px-1">
                        <i className="icon-delete" />
                      </button>
                      <button type="button" name="Add" className="btn  px-1">
                        <i className="icon-add" />
                      </button>
                    </td>
                  )}
                </tr>
                <tr key={2}>
                  <td colSpan={6}>
                    <input
                      type="text"
                      name="destination"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.DESTINATIONS')}
                      className="form-control text-bordered"
                      disabled
                    />
                    <div className="d-flex align-items-center my-1">
                      <span>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_PACKS_')}</span>
                      <div className="ml-auto">
                        <input
                          type="text"
                          name="packsQuantity"
                          placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.PACK')}
                          className="form-control text-bordered"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="d-flex align-items-center my-1">
                      <span>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_UNITS_')}</span>
                      <div className="ml-auto">
                        <input
                          type="text"
                          name="totalUnits"
                          placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.UNIT')}
                          className="form-control text-bordered"
                          disabled
                        />
                      </div>
                    </div>
                  </td>
                  {fromAddEdit && (
                    <td className="w-80px">
                      <button type="button" name="Delete" className="btn px-1">
                        <i className="icon-delete" />
                      </button>
                      <button type="button" name="Add" className="btn  px-1">
                        <i className="icon-add" />
                      </button>
                    </td>
                  )}
                </tr>

                <tr key={3}>
                  <td colSpan={7}>
                    <strong className="d-flex align-item-center justify-content-center">
                      {t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL')}
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td className="w-250px">
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.AUTOFILLED_TEXT')}</strong>
                  </td>
                  <td className="w-250px">
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.AUTOFILLED_TEXT')}</strong>
                  </td>
                  <td className="w-250px">
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.PO_AUTO_FIELD')}</strong>
                  </td>
                  <td colSpan={3}>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_PACKS:')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.PO_AUTO_FIELD')}</strong>
                  </td>
                </tr>
                <tr>
                  <td colSpan={3}>
                    <strong className="d-flex justify-content-center align-items-center">-</strong>
                  </td>
                  <td colSpan={3}>
                    <strong> {t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.TOTAL_UNITS:')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_DESTINATION_PACK_UNIT.AUTO')}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card.Body>
      )}
    </Card>
  );
}

export default MultiDestinationPackUnits;
